var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout',[_c('PageHeader',{attrs:{"add":{icon: 'bx bx-add-to-queue bx-tada', title: 'general.new', link: ''},"title":_vm.$t('commission.text')}}),_c('List',{attrs:{"dataList":_vm.commissionData,"updating":_vm.fetchingStats,"navigate":_vm.pageNavigate,"deletes":[_vm.deleted, null],"formats":[{name: 'commission', type: 'currency', sign: '$'}, {name: 'pay_date', type: 'date'}, {name: 'status', color: true}, {name: 'commission_paid', type: 'currency', sign: '$'}],"fields":[ ("code: " + (_vm.$t('commission.code'))),
          ("customer: " + (_vm.$t('customer.text'))),  ("property: " + (_vm.$t('property.text'))), ("seller: " + (_vm.$t('seller.text'))),
          ("commission: " + (_vm.$t('commission.commission-amount'))), ("commission_paid: " + (_vm.$t('commission.commission-paid'))), 
          ("pay_date: " + (_vm.$t('payment.pay_date'))), ("status: " + (_vm.$t('property.status')))
        ],"view":{link: 'commission-view'},"more":{
          sub: [{
            name: 'invoice.print', icon: 'bx bx-printer', link: 'commission-print', column: 'id', target: '_blank'
          },{
            name: 'commission.finish', icon: 'bx bx-check-double', action: 'finish', column: 'id', show: {column: 'commission_status_id', value: 1}
          },{
            name: 'commission.change-date', icon: 'bx bx-calendar', link: 'commission-edit', column: 'id'
          },{
            name: 'commission.pay', icon: 'bx bx-list-check', link: 'commission-paid', column: 'id', show: {column: 'commission_status_id', value: 1}
          },{
            name: 'commission.pay', icon: 'bx bx-list-check', link: 'commission-paid', column: 'id', show: {column: 'commission_status_id', value: 2}
          }] 
        },"filter":{
          search: ['commissions.code', 'commissions.name', 'properties.code'],
          dropdown: [{
            title: 'seller.text',
            field: 'commissions.seller_id',
            data: this.sellerData.data,
            width: 2,
          }, {
            title: 'property.status',
            field: 'commissions.commission_status_id',
            data: this.commissionStatusData.data,
            width: 2,
          }],
          date: {
            title: 'general.date',
            field: 'commissions.created_by'
          }
        }},on:{"more":_vm.moreClick}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }